import { render } from "./Mikomi_Type_Game.vue?vue&type=template&id=4fc5b826"
import script from "./Mikomi_Type_Game.vue?vue&type=script&lang=js"
export * from "./Mikomi_Type_Game.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__